export default __webpack_public_path__ + "static/sunset-2e552efe1c1377141cffb92babd22b1e.jpg";